// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EJiN","footer":"styles_footer__yN92q"};